import request from "../axios/axios";
import { AxiosMethod } from "../entities/Environment";
import {
  CalculateRatioItemResponseInterface,
  CalculateRatioRequestInterface,
} from "../entities/VolumeEngine";

export enum VolumeEngineEndpoints {
  CALCULATE_RATIO = "volume-engine/ratio",
}

export class VolumeEngineService {
  public static readonly getCalculatedRatioOfCondiments = (
    data: CalculateRatioRequestInterface,
  ): Promise<CalculateRatioItemResponseInterface[]> => {
    return request({
      url: VolumeEngineEndpoints.CALCULATE_RATIO,
      method: AxiosMethod.POST,
      data,
    });
  };
}
